/* global axios */
import ApiClient from './ApiClient';

const buildParams = params =>
  new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  ).toString();

class TasksApiClient extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    const {
      conversation_id: conversationId,
      contact_id: contactId,
      company_id: companyId,
      deal_id: dealId,
      assigned_to_id: assignedToId,
      start,
      end,
    } = params;
    const requestURL = `${this.url}?${buildParams({
      conversation_id: conversationId,
      contact_id: contactId,
      company_id: companyId,
      deal_id: dealId,
      assigned_to_id: assignedToId,
      start,
      end,
    })}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  stats(params = {}) {
    const { assigned_to_id: assignedToId } = params;
    return axios.get(
      `${this.url}/stats?${buildParams({ assigned_to_id: assignedToId })}`
    );
  }

  create(taskData) {
    return axios.post(this.url, { task: taskData });
  }

  update(id, taskData, { scope, occurrenceDate } = {}) {
    return axios.patch(`${this.url}/${id}`, {
      task: taskData,
      scope,
      occurrence_date: occurrenceDate,
    });
  }

  destroy(id, { scope, occurrenceDate } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: { scope, occurrence_date: occurrenceDate },
    });
  }
}

export default new TasksApiClient();
